"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usageTrackerMiddleware;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _constants = require("composer-lib/lib/constants");

function usageTrackerMiddleware(Tracker) {
  (0, _UsageTracking.setUsageTracker)(Tracker);
  return function () {
    return function (next) {
      return function (action) {
        if (!Tracker || !action.meta || !action.meta[_constants.TRACK_EVENT_META_KEY]) {
          return next(action);
        }

        var eventData = action.meta[_constants.TRACK_EVENT_META_KEY];
        (0, _UsageTracking.trackEvent)(eventData);

        if (action.type !== _ActionTypes.default.TRACK_EVENT) {
          return next(action);
        }

        return undefined;
      };
    };
  };
}

module.exports = exports.default;